<template>
  <div class="app">
    <main>
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
export default {};
</script>

<style>
@import './assets/scss/style.scss';
@import './assets/scss/responsive.css';
</style>



// WEBPACK FOOTER //
// src/App.vue